import { render, staticRenderFns } from "./registerSuccess.vue?vue&type=template&id=3d98c0b6&scoped=true"
import script from "./registerSuccess.vue?vue&type=script&lang=js"
export * from "./registerSuccess.vue?vue&type=script&lang=js"
import style0 from "./registerSuccess.vue?vue&type=style&index=0&id=3d98c0b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d98c0b6",
  null
  
)

export default component.exports